import { apiClient } from './client';
import type { DepartmentAccessGroup, DepartmentAccessGroups, DepartmentAccessGroupWrite } from '@/types/oscar';

/**
 * Typed wrappers over the department access group endpoints
 * (DepartmentAccessGroupFunctions). Reads open to any authenticated Oscar user;
 * mutations are admin-only (enforced server-side).
 */

/** GET /api/onboarding/access-groups — every live mapping plus the OnsiteLive groups on offer. */
export function listDepartmentAccessGroups(signal?: AbortSignal): Promise<DepartmentAccessGroups> {
  return apiClient.get<DepartmentAccessGroups>('/api/onboarding/access-groups', signal);
}

/** POST /api/onboarding/departments/:code/access-groups — add a group to a department (admin). */
export function addDepartmentAccessGroup(code: string, body: DepartmentAccessGroupWrite): Promise<DepartmentAccessGroup> {
  return apiClient.post<DepartmentAccessGroup>(`/api/onboarding/departments/${encodeURIComponent(code)}/access-groups`, body);
}

/** POST /api/onboarding/access-groups/:id/remove — soft delete (admin). */
export function removeDepartmentAccessGroup(id: number): Promise<{ DepartmentAccessGroupId: number; IsDeleted: boolean }> {
  return apiClient.post<{ DepartmentAccessGroupId: number; IsDeleted: boolean }>(`/api/onboarding/access-groups/${id}/remove`);
}
